export enum Column {
  Date = 'Date',
  Value = 'Value',
  OperationType = 'OperationType',
  Comment = 'Comment'
}
